import Axios from 'axios';
import { protectedResources } from '../authConfig';

const URL_UPLOAD =
  protectedResources.apiHRMobile.baseApi +
  '/api/v1/BackOffice/SetAdvanceSalaryImport';
let tokenKey;

export async function UploadExcelMasterFile(fileInput, limit, offset, batchNo) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }
  var formData = new FormData();
  var imagefile = document.querySelector('#file');
  formData.append('Image', fileInput);
  formData.append('limit', limit);
  formData.append('offset', offset);
  formData.append('batchNo', batchNo);
  const config = {
    headers: {
      Authorization: `Bearer ${tokenKey}`,
      'Content-Type': 'multipart/form-data',
    },
  };
  try {
    const response = await Axios.post(URL_UPLOAD, formData, config);
    return await response;
  } catch (error) {
    throw new Error(error.response.data.detail);
  }
}
